import { createSlice } from "@reduxjs/toolkit";

import basicGrid from "../assets/thumbnails/templates/basic-grid.svg";
import large from "../assets/thumbnails/templates/large.png";

import withGridLines from "../assets/thumbnails/templates/gridlines.png";

import welcomeData from "../assets/data/welcome.json";
import empty3x3Data from "../assets/data/empty3x3.json";
import emptyLargeData from "../assets/data/emptyLarge.json";

export const templatesSlice = createSlice({
  name: "templates",
  initialState: {
    welcome: welcomeData,
    all: [
      {
        id: "3x3",
        thumbnail: basicGrid,
        ...empty3x3Data,
      },
      {
        id: "large",
        thumbnail: large,
        ...emptyLargeData,
      },
      {
        id: "withGridLines",
        thumbnail: withGridLines,
        ...empty3x3Data,
        borders: [
          {
            id: "d04a4bcb-cab5-46bc-bfa5-180b7c20d12e",
            index: 0,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "70742a92-cf47-410e-851f-84303a041ee4",
            index: 1,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "ca8179e5-1445-489c-b86f-3a8bcbb48ef1",
            index: 2,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "d3743039-3874-4a89-afb9-452647daafd0",
            index: 3,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "d8c7d54c-0795-4e0d-990d-0ca59616108f",
            index: 0,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "9e55ea31-b2bb-436e-9526-a7cab5a20f7b",
            index: 1,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "4924c6e5-458b-4751-b01f-9cbee47dd85a",
            index: 2,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "bab3e009-bbac-483e-9475-7a5ea4c31f04",
            index: 3,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "5675c10c-9698-4908-9f3c-62b4af4014a3",
            index: 0,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "8ee22005-42db-456d-b3ec-9fcafba42468",
            index: 1,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "c62c3cee-1b67-4cad-9508-6cfa90a8500f",
            index: 2,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "4a409d6a-8d73-4907-850c-d959e55e5c14",
            index: 3,
            isVertical: true,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "573f6964-4717-43a2-811b-2662ada3137f",
            index: 0,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "ffa5a3f9-08f3-4755-b919-9132f1756802",
            index: 1,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "6e18a450-60c8-457f-bf54-416971687a14",
            index: 2,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
          {
            id: "6d9e23a5-d51c-4863-9374-94ff08ece3fc",
            index: 3,
            isVertical: false,
            weight: 3,
            color: "#333333",
            style: "solid",
            from: 0,
            to: null,
            preset: "level1",
          },
        ],
      },
    ],
  },
});

export default templatesSlice.reducer;
